<template>
  <BaseVeeForm :action="submit" ensure-error-keys-camel-case v-slot="formProps" class="space-y-8">
    <VModal ref="modal" @modal:hidden="$emit('hide')" :disable-backdrop-click="formProps.isPending">
      <div class="mx-auto bg-white rounded-lg text-left shadow-xl max-w-lg w-full">
        <div class="flex flex-col">
          <div class="flex-none px-4 py-4 sm:px-6 border-b border-gray-200">
            <div class="flex justify-between items-center">
              <div class="flex-1">New Product Reaction</div>
              <div class="flex-none">
                <button
                  type="button"
                  class="rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  @click="close"
                >
                  <span class="sr-only">Close</span>
                  <svg
                    class="inline-flex h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div class="flex-1 px-4 pt-4 pb-4 sm:pb-6 sm:px-6">
            <div class="space-y-8">
              <div class="space-y-4">
                <ValidationProvider name="product" slim vid="accProductId" rules="required">
                  <template #default="{ errors }">
                    <BaseFormGroup>
                      <BaseFormLabel> Product </BaseFormLabel>
                      <VSelect
                        v-model="formData.accProductId"
                        :options="accProductOptions"
                        :reduce="(accProduct) => accProduct.value"
                        :filterable="false"
                        :disabled="formProps.isPending"
                        @search="onSearch"
                        class="vue-select"
                      />
                      <BaseFormInlineMessage v-if="errors.length" danger>
                        {{ errors[0] }}
                      </BaseFormInlineMessage>
                    </BaseFormGroup>
                  </template>
                </ValidationProvider>
                <ValidationProvider
                  name="reaction"
                  rules="required"
                  slim
                  vid="accProductReactionTypeId"
                >
                  <template #default="{ errors }">
                    <BaseFormGroup>
                      <BaseFormLabel> Reaction </BaseFormLabel>
                      <div>
                        <BaseFormSelect
                          v-model="formData.accProductReactionTypeId"
                          :options="accProductReactionTypeOptions"
                          :disabled="formProps.isPending"
                        />
                      </div>
                      <BaseFormInlineMessage v-if="errors.length" danger>
                        {{ errors[0] }}
                      </BaseFormInlineMessage>
                    </BaseFormGroup>
                  </template>
                </ValidationProvider>
              </div>
              <div class="flex space-x-2">
                <BaseButton primary :disabled="formProps.invalid || formProps.isPending">
                  Save
                </BaseButton>
                <BaseButton
                  type="button"
                  primary
                  outline
                  :disabled="formProps.isPending"
                  @click="close"
                >
                  Cancel
                </BaseButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </VModal>
  </BaseVeeForm>
</template>

<script>
import { debounce } from 'lodash-es';

export default {
  name: 'AccProductReactionCreateModal',
  props: {
    action: {
      type: Function,
      required: true,
    },
    accProductReactionTypeOptions: {
      type: Array,
      default: () => [],
    },
    searchAccProducts: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      formData: {
        accProductId: null,
        accProductReactionTypeId: null,
      },
      accProductOptions: [],
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    close() {
      this.$refs.modal.close();
    },
    async loadData() {
      try {
        const accProducts = await this.searchAccProducts();

        this.setAccProductOptions(accProducts);

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async onSearch(search, loading) {
      if (typeof this.searchAccProducts === 'function' && search.length) {
        loading(true);
        this.search(loading, search, this);
      }
    },
    search: debounce(async (loading, search, vm) => {
      const accProducts = await vm.searchAccProducts(search);

      vm.setAccProductOptions(accProducts);

      loading(false);
    }, 500),
    setAccProductOptions(accProducts) {
      this.accProductOptions = accProducts.map((accProduct) => ({
        value: accProduct.id,
        label: accProduct.name,
      }));
    },
    async submit() {
      try {
        await this.action(this.formData);

        this.close();

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
